import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {AbstractRepositoryV2} from "../../../../../../core/service/v2/abstractRepositoryV2";
import {ProductStockUnitModel} from "../../../api/entity/productStockUnit.model";

@Injectable({
    providedIn: 'root'
})
export class ProductStockUnitRepository extends AbstractRepositoryV2<ProductStockUnitModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('ProductStockUnit', serviceElementsFactory, injector);
    }
}
